export interface SavedOrderEntry {
  Id?: number;
  order: number;
  title?: string | null;
}

export type SavedOrderMap = Record<string, SavedOrderEntry[]>;

export const parseSavedOrder = (raw: string | null): SavedOrderMap => {
  if (!raw) return {};
  try {
    return JSON.parse(raw) as SavedOrderMap;
  } catch {
    return {};
  }
};

export const resolveItemOrder = (
  saved: SavedOrderMap,
  laneName: string,
  id: number | undefined,
  fallbackOrder: number
): number => {
  const entry = saved[laneName]?.find((x) => x.Id === id);
  return entry ? entry.order : fallbackOrder;
};
